// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-in;
}

.loader-box {
  background: white;
  padding: 48px 60px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  animation: slideUp 0.4s ease-out;
}

.loader-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loader-title {
  font-size: 24px;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.loader-message {
  font-size: 16px;
  font-weight: 500;
  color: #424242;
  margin-bottom: 12px;
  min-height: 24px;
  animation: fadeInOut 3s ease-in-out infinite;
}

.loader-subtext {
  font-size: 14px;
  font-weight: 400;
  color: #757575;
  margin-top: 8px;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeInOut {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/GenerateLoader.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE;IACE,2BAAA;IACA,UAAA;EAAF;EAEA;IACE,wBAAA;IACA,UAAA;EAAF;AACF;AAGA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF;AAIA;EACE;IACE,YAAA;EAFF;EAIA;IACE,UAAA;EAFF;EAIA;IACE,YAAA;EAFF;AACF","sourcesContent":[".loader-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease-in;\n}\n\n.loader-box {\n  background: white;\n  padding: 48px 60px;\n  border-radius: 16px;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  animation: slideUp 0.4s ease-out;\n}\n\n.loader-icon {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid #e0e0e0;\n  border-top: 4px solid #1976d2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loader-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1976d2;\n  margin-bottom: 16px;\n  letter-spacing: -0.5px;\n}\n\n.loader-message {\n  font-size: 16px;\n  font-weight: 500;\n  color: #424242;\n  margin-bottom: 12px;\n  min-height: 24px;\n  animation: fadeInOut 3s ease-in-out infinite;\n}\n\n.loader-subtext {\n  font-size: 14px;\n  font-weight: 400;\n  color: #757575;\n  margin-top: 8px;\n  font-style: italic;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.7;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
